import ReportTable from './Report/ReportTable';

const ReportPage = () => {
  return <ReportTable />;
};

export default ReportPage;
